import React, { useEffect, useRef } from 'react'
import { getRouteApi } from '@tanstack/react-router'
import MainLayout from 'components/layouts/main-layout'
import Header from 'components/layouts/header/header'
import DictionarySearchBar from 'components/search/dictionary-search-bar'
import QueryResultContainer from 'components/query-result/query-result-container'
import EngDictionaryPage from 'components/dictionary/english/eng-dictionary-page'
import useTranslationForm from 'hooks/useTranslationForm'

const route = getRouteApi('/english/$word')

const EnglishWordPage = () => {
   const result = route.useLoaderData()
   const textareaRef = useRef<HTMLTextAreaElement | null>(null)
   const { onSubmit, resetForm, control, register, setValue } = useTranslationForm(textareaRef)

   const { word } = result.engDictionaryWord

   // Show the entry being read in the search box, the way arriving on `/?q=`
   // does — so editing it is how you search for something near it.
   useEffect(() => {
      setValue('sourceText', word)
   }, [word, setValue])

   return (
      <MainLayout>
         <Header
            compact
            onClick={resetForm}
            onModalClose={() => {
               onSubmit()
            }}
         >
            <DictionarySearchBar
               register={register}
               control={control}
               onSubmit={onSubmit}
               onClear={resetForm}
               textareaRef={textareaRef}
            />
         </Header>
         <div className="translation">
            <section>
               <QueryResultContainer>
                  <EngDictionaryPage
                     engDictionaryWord={result.engDictionaryWord}
                     translations={result.engDictionaryTranslations}
                     exampleSentences={result.exampleSentences}
                     exampleSentencesByMeaningId={result.exampleSentencesByMeaningId}
                  />
               </QueryResultContainer>
            </section>
         </div>
      </MainLayout>
   )
}

export default EnglishWordPage
